import { Axios } from "../utils/axios";
//获取列表
function getStudentsGradeList(page, pageSize) {
  return new Promise((resolve, reject) => {
    Axios.get("/trainAdmin/statistics/getStudyStatisticsByDept", {
      params: {
        //分页
        trainId: page,
        limit: pageSize
      }
    }).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
function getTrendsData(params) {
  return new Promise((resolve, reject) => {
    Axios.get("/trainAdmin/statistics/getStudyTrendStatistics", {
      params
    }).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
function getStatisticsData(params) {
  return new Promise((resolve, reject) => {
    Axios.get("/trainAdmin/statistics/getStudyCompleteStatistics", {
      params
    }).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//获取考试成绩
function getGradesTable(params) {
  return new Promise((resolve, reject) => {
    Axios.get("/trainAdmin/questionMemberInfo/score", {
      params
    }).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}

//获取考试成绩
function login(params) {
  return new Promise((resolve, reject) => {
    Axios.post("/system/auth/login", params).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//获取题库列表
function getQuestionBankTable(params) {
  return new Promise((resolve, reject) => {
    Axios.get("/trainAdmin/enterAdmin/list", {
      params
    }).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//新增试题
function addQuestion(params) {
  return new Promise((resolve, reject) => {
    Axios.post("/trainAdmin/enterAdmin/add", params).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//修改试题
function editQuestion(params) {
  return new Promise((resolve, reject) => {
    Axios.post("/trainAdmin/enterAdmin/update", params).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}

//删除试题
function removeQuestion(id) {
  return new Promise((resolve, reject) => {
    Axios.delete(`/trainAdmin/enterAdmin/${id}`).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}

//获取题库详情
function getQuestionBankDetail(id) {
  return new Promise((resolve, reject) => {
    Axios.get(`/trainAdmin/enterAdmin/${id}`).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//获取试卷列表
function getPaperTable(params) {
  return new Promise((resolve, reject) => {
    Axios.get("/trainAdmin/questionPaperInfo/list?" + params).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}

//新增试卷
function addPaper(params) {
  return new Promise((resolve, reject) => {
    Axios.post("/trainAdmin/questionPaperInfo", params).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//修改试卷
function editPaper(params) {
  return new Promise((resolve, reject) => {
    Axios.put("/trainAdmin/questionPaperInfo", params).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//删除试卷
function removePaper(id) {
  return new Promise((resolve, reject) => {
    Axios.delete(`/trainAdmin/questionPaperInfo/${id}`).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}

//关联试题列表
function getTestPaperList(params) {
  return new Promise((resolve, reject) => {
    Axios.get("/trainAdmin/questionPaperDetail/list", { params }).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}

//保存试卷
function savePaper(params) {
  return new Promise((resolve, reject) => {
    Axios.post("/trainAdmin/questionPaperDetail/setScore", params).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}

//查看试卷详情
function lookPaperInfo(id) {
  return new Promise((resolve, reject) => {
    Axios.get(
      `/trainAdmin/questionPaperDetail/queryInfo?questionPaperId=${id}`
    ).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}

function lookPaperAnswer(id) {
  return new Promise((resolve, reject) => {
    Axios.get(
      `/trainAdmin/questionPaperDetail/queryInfoAnswer?questionPaperId=${id}`
    ).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//获取证书列表
function getCertificateTable(pageNum, pageSize) {
  return new Promise((resolve, reject) => {
    Axios.get("/trainAdmin/certificate/list", {
      params: {
        //分页
        pageNum: pageNum,
        pageSize: pageSize
      }
    }).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//查找所有证书
function getCertificateTable1(params) {
  return new Promise((resolve, reject) => {
    Axios.get("/trainAdmin/certificate/list", { params }).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//新增证书
function addCertificate(params) {
  return new Promise((resolve, reject) => {
    Axios.post("/trainAdmin/certificate", params).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//编辑证书
function editCertificate(params) {
  return new Promise((resolve, reject) => {
    Axios.put("/trainAdmin/certificate", params).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//删除证书
function removeCertificate(id) {
  return new Promise((resolve, reject) => {
    Axios.delete(`/trainAdmin/certificate/${id}`).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//查找所有课程
function querySubject(params) {
  return new Promise((resolve, reject) => {
    Axios.get("/trainAdmin/statistics/allTrain", params).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//查找所有课程
function querySubject1(params) {
  return new Promise((resolve, reject) => {
    Axios.get("/trainAdmin/certificate/allTrain", params).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}

//获取用户列表
function getUserTable(pageNum, pageSize) {
  return new Promise((resolve, reject) => {
    Axios.get("/member/memberAdmin/list", {
      params: {
        //分页
        pageNum: pageNum,
        pageSize: pageSize
      }
    }).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//成绩管理-关联课程
function classGrade(params) {
  return new Promise((resolve, reject) => {
    Axios.get("/trainAdmin/questionMemberInfo/allCourse", params).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}

function getRecycleList(params) {
  return Axios.get("/trainAdmin/questionRecycle/list", { params });
}
function delRecycle(id) {
  return new Promise((resolve, reject) => {
    Axios.delete(`/trainAdmin/questionRecycle/${id}`).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
function addRecycle(id) {
  return new Promise((resolve, reject) => {
    Axios.post(`/trainAdmin/questionRecycle/restore/${id}`).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
function questionUpload(data) {
  return new Promise((resolve, reject) => {
    Axios.post(`/trainAdmin/enterAdmin/import`, data, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" }
    }).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}

export {
  getStudentsGradeList,
  getTrendsData,
  getStatisticsData,
  getGradesTable,
  login,
  getQuestionBankTable,
  getPaperTable,
  getQuestionBankDetail,
  addQuestion,
  removeQuestion,
  editQuestion,
  getCertificateTable,
  addPaper,
  editPaper,
  removePaper,
  getTestPaperList,
  savePaper,
  addCertificate,
  lookPaperInfo,
  getUserTable,
  querySubject,
  classGrade,
  removeCertificate,
  editCertificate,
  querySubject1,
  getCertificateTable1,
  getRecycleList,
  delRecycle,
  addRecycle,
  lookPaperAnswer,
  questionUpload
};



// WEBPACK FOOTER //
// ./src/api/manage.js